module.exports = __webpack_public_path__ + "static/icon__code--multicolor-41f4e4baa98517448d7ff317a705fce8.png";